import { render } from "./SecretAdd.vue?vue&type=template&id=41872e4a&ts=true"
import script from "./SecretAdd.vue?vue&type=script&lang=ts"
export * from "./SecretAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__